'use strict';

import { Entity } from '../Entity';

export class IndDrugNone extends Entity {
  protected indDrugId;

  protected indId;

  protected indDrugNote;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indDrugId = data.indDrugId;

    this.indId = data.indId;

    this.indDrugNote = data.indDrugNote;
  }

  public getIndDrugId() {
    return this.indDrugId;
  }

  public setIndDrugId(indDrugId) {
    this.indDrugId = indDrugId;

    return this;
  }

  public getIndId() {
    return this.indId;
  }

  public setIndId(indId) {
    this.indId = indId;

    return this;
  }

  public getIndDrugNote() {
    return this.indDrugNote;
  }

  public setIndDrugNote(indDrugNote) {
    this.indDrugNote = indDrugNote;

    return this;
  }
}
